import t from "../../Actions/CloudVpcActions/type";

const initialState = {
  vpcDevices: [],
  selectedVpc: null,
  modelOpenClose: false,
  isCreateMode: true,
  loader: false,
  message: {
    isSuccess: false,
    message: "",
  },
  schedulerData: [],
};

/**
 * Reducer for Cloud VPC
 * Fixed: 'default-param-last' by moving the default assignment into the body.
 */
const Reducer = (state, action) => {
  // Manual default parameter assignment to satisfy linter
  const currentState = state || initialState;

  switch (action.type) {
    case t.VPC_LOADER:
      return { ...currentState, loader: action.payload };

    case t.FETCH_CLOUD_VPC_DEVICES:
      return {
        ...currentState,
        vpcDevices: action.payload,
        loader: false,
      };

    case t.SET_VPC_DEVICE_DATA:
      return { ...currentState, selectedVpc: action.payload };

    case t.CLOSE_OPEN_MODEL:
      return { ...currentState, modelOpenClose: action.payload };

    case t.SET_VPC_CREATE_FLAG:
      return { ...currentState, isCreateMode: action.payload };

    case t.ADD_CLOUD_VPC:
      return {
        ...currentState,
        vpcDevices: [action.payload, ...currentState.vpcDevices],
        loader: false,
      };

    case t.EDIT_CLOUD_VPC: {
      const updatedList = currentState.vpcDevices.map((item) => (item.id === action.payload.id ? { ...item, ...action.payload } : item));
      return {
        ...currentState,
        vpcDevices: updatedList,
        loader: false,
      };
    }

    case t.DELETE_CLOUD_VPC: {
      const filteredList = currentState.vpcDevices.filter((item) => item.id !== action.payload.id);
      return {
        ...currentState,
        vpcDevices: filteredList,
        loader: false,
      };
    }

    case t.GET_VPC_SCHEDULER_DATA:
      return { ...currentState, schedulerData: action.payload };

    case t.SET_VPC_DEVICE_ERROR:
      return {
        ...currentState,
        message: {
          isSuccess: action.payload?.isSuccess || false,
          message: action.payload?.message || action.payload,
        },
        loader: false,
      };

    default:
      return currentState;
  }
};

export default Reducer;
